export default {
	common: {
		appTitle: 'Soft AI',
		loading: 'Loading…',
		loadMore: 'Load more',
	},

	language: {
		title: 'Language',
		subtitle: 'Choose your preferred language',
		description:
			'The interface, menus and character descriptions will be displayed in the language you select. You can change it at any time.',
		selectLanguage: 'Select language',
		active: 'Selected',
		pl: 'Polski',
		plDescription: 'Polish interface and content',
		de: 'Deutsch',
		deDescription: 'German interface and content',
		en: 'English',
		enDescription: 'English interface and content',
		cs: 'Čeština',
		csDescription: 'Czech interface and content',
		close: 'Close',
	},

	login: {
		title: 'Soft AI',
		subtitle: 'Find your perfect companion.',
		subtitleLogin: 'Enter your password to continue.',
		subtitleSetPassword:
			'Your account already exists. Set a password to log in.',
		subtitleRegister: 'Create your account to get started.',
		emailLabel: 'Email Address',
		emailPlaceholder: 'Enter your email',
		passwordLabel: 'Password',
		passwordPlaceholder: '••••••••',
		passwordSetPlaceholder: 'create your password',
		passwordLabelRegister: 'Set Password',
		confirmPasswordLabel: 'Confirm Password',
		confirmPasswordPlaceholder: 'Confirm your password',
		loginButton: 'Log In',
		loggingIn: 'Logging in...',
		checkingEmail: 'Checking email...',
		registering: 'Creating account...',
		loginSuccessButton: 'Logged in',
		registerSuccessButton: 'Account created',
		continueButton: 'Continue',
		registerButton: 'Register',
		setPasswordButton: 'Set password',
		forgotPasswordLink: 'Forgot password?',
		registerLink: 'Register',
		goBackLink: 'Change Email',
		resetPasswordLink: 'Reset Password',
		resetModalTitle: 'Reset Your Password',
		resetModalHint: 'Enter your email and we will send you a link to reset your password.',
		sendResetLinkButton: 'Send Reset Link',
		resetSending: 'Sending...',
		resetBackToLogin: 'Back to log in',
		resetSuccessTitle: 'Check your email',
		resetSuccessHint: 'We sent you a password reset link.',
		resetSuccessMessage:
			'If an account exists for this email, you will receive a reset link shortly. Check your inbox and spam folder.',
		passwordMismatch: 'Passwords do not match.',
		passwordRequirements: 'At least 6 characters.',
		passwordTooShort: 'Password must be at least 6 characters.',
		passwordNeedsNumber: 'Password must include at least one number.',
		passwordNeedsSpecial:
			'Password must include at least one special character.',
		errorMessage: 'Invalid email address or password. Please try again.',
		wrongPasswordMessage: 'Incorrect password. Please try again.',
		accountExistsLogin: 'This account already exists. Please log in.',
		showPassword: 'Show password',
		hidePassword: 'Hide password',
	},

	restartPassword: {
		statusLoading: 'Checking',
		statusReady: 'Reset',
		statusSuccess: 'Done',
		statusInvalid: 'Expired',
		loadingTitle: 'Checking your link',
		loadingMessage: 'Please wait while we verify your password reset link.',
		invalidTitle: 'This link is no longer valid',
		invalidMessage:
			'The password reset link has expired or was already used. Request a new one from the login screen.',
		successTitle: 'Password updated',
		successMessage: 'Your new password is ready. You can now log in to Soft AI.',
		formTitle: 'Set a new password',
		formMessage: 'Choose a new password for your account. The link is valid for 24 hours.',
		passwordLabel: 'New password',
		passwordPlaceholder: 'Enter new password',
		confirmPasswordLabel: 'Confirm password',
		confirmPasswordPlaceholder: 'Repeat new password',
		passwordRequirements: 'At least 6 characters.',
		passwordResetTooShort: 'Password must be at least 6 characters.',
		passwordMismatch: 'Passwords do not match.',
		submitButton: 'Save new password',
		submitting: 'Saving...',
		backToApp: 'Back to Soft AI',
		showPassword: 'Show password',
		hidePassword: 'Hide password',
		errorGeneric: 'Could not update password. Try again or request a new link.',
	},

	studio: {
		createTitlePrefix: 'Create your',
		createTitleHighlight: 'Softie',
		navigation: 'Studio navigation',
		back: 'Back',
		next: 'Next',
		createSoftie: 'Create Softie',
		chooseGender: 'Choose gender',
		chooseEthnicity: 'Choose ethnicity',
		chooseHairstyle: 'Choose hairstyle',
		chooseHairColor: 'Choose hair color',
		chooseBodyType: 'Choose body type',
		chooseEyeColor: 'Choose eye color',
		chooseBreastSize: 'Choose breast size',
		chooseBulgeSize: 'Choose bulge size',
		chooseAge: 'Choose age',
		confirmAge: 'Confirm',
		ageLabel: 'Age',
		yearsOld: 'years old',
		finalTitle: 'Make your Softie truly yours',
		generatingTitle: 'Generating character',
		creatingSoftie: 'Creating your Softie',
		generatingHint: 'We are mixing the look, vibe and voice into one persona.',
		generatingPhaseLook: 'Sculpting the look',
		generatingPhasePersona: 'Weaving personality',
		generatingPhaseAwaken: 'Awakening',
		generatingPhoto: 'Generating photo...',
		estimatedPhotoTimeRemaining: 'Estimated time: {seconds}s',
		estimatedVideoTimeRemaining: 'Almost ready: {seconds}s',
		resultTitle: 'Your Softie awaits',
		awakenSoftie: 'Awaken Softie',
		meetMySoftie: 'Meet your Softie',
		rerollLook: 'Reroll look',
		name: 'Name',
		fieldEthnicity: 'Ethnicity',
		fieldAge: 'Age',
		fieldEyeColor: 'Eye color',
		fieldBodyType: 'Body type',
		fieldHairstyle: 'Hairstyle',
		fieldHairColor: 'Hair color',
		fieldBreastSize: 'Breast size',
		fieldBulgeSize: 'Bulge size',
		personality: 'Personality',
		occupation: 'Occupation',
		relationship: 'Relationship',
		nationality: 'Nationality',
		city: 'City',
		zodiac: 'Zodiac sign',
		kinks: 'Kinks',
		voice: 'Voice',
		confirmFinal: 'Confirm',
		namePlaceholder: 'Character name',
		cityPlaceholder: 'City',
		done: 'Done',
		gridOptionLabels: {},
		gender: {
			chooseGender: 'Choose gender',
			woman: 'Woman',
			men: 'Men',
			trans: 'Trans',
		},
	},

	imageGeneration: {
		title: 'AI Character Generator',
		subtitle:
			'Bring your fantasy to life: Choose every detail, from the gaze to the outfit.',
		characterName: 'Character Name',
		characterNamePlaceholder: 'e.g. Alexandra, Zoja, Carmen...',
		prompt: 'Prompt',
		promptPlaceholder:
			'e.g. Blonde in a red dress against a night city background...',
		randomPrompt: 'Not sure what to write? Click to generate a description!',
		customization: 'Character Customization',
		numberOfImages: 'Number of images to generate',
		imageCount: '{count} Image',
		imagesCount: '{count} Images',
		generating: 'Generating...',
		generateCharacter: 'Generate Character',
		historyTitle: 'Generated Character History',
		loading: 'Loading...',
		emojiIconAlt: 'Emoji icon',
	},

	nav: {
		mainNavigation: 'Main navigation',
		lounge: 'Lounge',
		discover: 'Discover',
		chat: 'Chat',
		studio: 'Studio',
		mySofties: 'My Softies',
	},

	topBar: {
		sparkBalance: 'Spark balance',
		openSparkPackages: 'Open Spark packages',
		totalBalance: 'Total Balance',
		account: 'Account',
		logIn: 'Log in',
		register: 'Register',
	},

	authModal: {
		loginTitle: 'Log in to continue',
		registerTitle: 'Create your account',
		loginHint: 'Welcome back. Sign in to start chatting with your Softies.',
		registerHint: 'Create a free account to unlock chat and save your companions.',
		visualTitle: 'Meet your Softies',
		visualDescription:
			'Create companions, explore styles, and unlock chat with a free account.',
		loginVisualTitle: 'Welcome back',
		loginVisualDescription: 'Sign in and pick up where you left off with your Softies.',
		guestBrowseHint:
			'Browse characters for free. Log in or register to chat, create Softies, and unlock full access.',
		hasAccountPrompt: 'Already have an account?',
		switchToLogin: 'Log in',
		noAccountPrompt: "Don't have an account yet?",
		switchToRegister: 'Create one',
		loginAction: 'Log in',
		registerAction: 'Register',
		continueBrowsing: 'Continue browsing',
		tabSwitcherLabel: 'Authentication mode',
		close: 'Close',
	},

	sparkModal: {
		premiumAccess: 'Premium Access',
		premiumDescription:
			'Top up sparks to generate images, videos and unique moments without waiting.',
		closeSparkPackages: 'Close Spark packages',
		selectPackage: 'Select a package',
		usageTitle: 'How sparks are used:',
		messageUsage: 'Message:',
		messageUsageValue: '0 sparks',
		voiceUsage: 'Voice:',
		voiceUsageValue: '0 sparks',
		photoUsage: 'Photo:',
		photoUsageValue: '5 sparks',
		videoUsage: 'Video:',
		videoUsageValue: '50 sparks',
		characterUsage: 'Character creation:',
		characterUsageValue: '100 sparks',
		sparkPackages: 'Spark packages',
		termsOfService: 'Terms of Service',
		privacyPolicy: 'Privacy Policy',
		acceptTermsPrefix: 'I accept the',
		acceptTermsAnd: 'and',
		selectPackageButton: 'Select a package',
		continueWithPrice: 'Continue ({price})',
		packages: {
			basic: {
				name: 'BASIC',
				sparks: '1000 sparks',
			},
			pro: {
				name: 'PRO',
				sparks: '3000 sparks',
			},
			premium: {
				name: 'PREMIUM',
				sparks: '6000 sparks',
			},
		},
	},

	profileAccount: {
		account: 'Account',
		displayName: 'Display name',
		nameRequired: 'Display name is required.',
		nameSaveError: 'Could not save display name. Please try again.',
		tokens: 'Tokens',
		planValidUntil: 'Plan valid until',
		memberSince: 'Member since:',
		support: 'Support: support@softai.today',
		supportLabel: 'Support',
		supportEmail: 'support@softai.today',
		logOut: 'Log out',
		loggingOut: 'Logging out...',
		privacyPolicy: 'Privacy Policy',
		termsOfUse: 'Terms of Use',
	},

	home: {
		stories: 'Stories',
		previousStories: 'Previous stories',
		nextStories: 'Next stories',
		storyClose: 'Close story',
		storyPrev: 'Previous story',
		storyNext: 'Next story',
		storyPlay: 'Play',
		storyPause: 'Pause',
		storyTimeAgo: '5h',
		storyReplyPlaceholder: 'Write a message...',
		storyReplySend: 'Send',
		loungeHighlight: 'Lounge highlight',
		loungeTitlePrefix: 'Pick your',
		loungeTitleSoftie: 'Softie',
		loungeTitleMiddle: ', follow the',
		loungeTitleVibe: 'vibe',
		surpriseMe: 'Surprise me',
		loungeCategories: 'Lounge categories',
		previousCategories: 'Previous categories',
		nextCategories: 'Next categories',
		categoriesLabel: 'Categories',
		all: 'All',
		loadingTags: 'Loading tags…',
		categories: {
			Neighbor: 'Neighbor',
			Romantic: 'Romantic',
			Sweet: 'Sweet',
			Naughty: 'Naughty',
			Mature: 'Mature',
			Luxury: 'Luxury',
			Fitness: 'Fitness',
			Bossy: 'Bossy',
			Nerdy: 'Nerdy',
			Trans: 'Trans',
			Mystic: 'Mystic',
			Fantasy: 'Fantasy',
			Men: 'Men',
		},
	},

	discover: {
		ariaLabel: 'Discover characters',
		back: 'Back to Lounge',
		swipeHint: 'Swipe up for more',
		loadingProfiles: 'Loading characters...',
	},

	mySofties: {
		titlePrefix: 'My',
		titleHighlight: 'Softies',
		createSoftie: 'Create your Softie',
	},

	profileModal: {
		close: 'Close profile',
		characterGallery: 'Character gallery',
		previousPhoto: 'Previous photo',
		nextPhoto: 'Next photo',
		photoNumber: 'Photo {number}',
		startChatting: 'Start chatting',
		meta: '{age} yrs · {origin}',
		defaultOrigin: 'Unknown',
		personalityAttributes: 'Personality Attributes',
		physicalAttributes: 'Physical Attributes',
		occupation: 'Occupation',
		relationship: 'Relationship',
		kinks: 'Kinks',
		ethnicity: 'Ethnicity',
		country: 'Country',
		age: 'Age',
		bodyType: 'Body Type',
		zodiacSign: 'Zodiac Sign',
		unknown: 'Unknown',
		defaultOccupation: 'Companion',
		defaultRelationship: 'Single',
		defaultZodiac: 'Libra',
		defaultKinks: 'Teasing',
	},

	profileCard: {
		portraitAlt: 'Portrait of {name}',
		regenerateImage: 'Regenerate image',
		ageShort: 'yrs',
	},

	chat: {
		conversationPanel: 'Conversation panel',
		companionProfile: 'Companion profile',
		loadingTitle: 'Loading Conversation...',
		loadingText: 'Fetching user and chat data. Please wait a moment.',
		noConversationTitle: 'No conversation selected',
		noConversationText:
			'Please select an existing conversation from the list or start a new one to begin chatting.',
		online: 'Online',
		back: 'Back',
		generatingImage: 'Generating image...',
		generatingVideo: 'Preparing your video...',
		estimatedTimeRemaining: 'Estimated time remaining: {seconds}s',
		estimatedTextTimeRemaining: 'Estimated time: {seconds}s',
		estimatedVideoTimeRemaining: 'Almost ready: {seconds}s',
		writeMessage: 'Write a message...',
		sendMessage: 'Send message',
		sendMePhoto: 'Send me a photo',
		sendMeVideo: 'Send me a video',
		call: 'Call',
		endCall: 'End call',
		callInProgress: 'Call in progress',
		voiceCallActive: 'Voice call active',
		voiceCallStartSpeaking: 'Start speaking...',
		voiceCallSpeaking: 'She is speaking...',
		voiceCallYouSpeaking: 'You are speaking...',
		voiceCallProcessing: 'Connecting response...',
		callMessage: 'Hey, are you there?',
		videoReply: 'Sure, here is your video.',
		videoNotAvailable: 'Video is not available for this companion yet.',
		fetchMessagesError:
			'Something went wrong while loading messages. Please try again.',
		illegalContentError:
			'Your message is not allowed. We cannot generate that content.',
		noTokensError: 'Out of sparks! Top up to continue creating.',
		imageGenerationError:
			'We could not generate the image. Please try again in a moment.',
		videoGenerationError:
			'We could not generate the video. Please try again in a moment.',
		guestGateTitle: 'Sign up to start chatting',
		guestGateDescription:
			'Create an account, pick a plan, and start talking to your Softie in minutes.',
		guestGateHeroTitle: 'Your Softie is waiting',
		guestGateHeroDescription:
			'Sign up to unlock chat, photos, and personalized moments.',
		guestGateRegister: 'Sign up',
		guestGateLogin: 'I already have an account',
		planPaywallTitle: 'Choose your plan',
		planPaywallDescription: 'Full access to chat and content creation.',
		planPaywallBenefitUncensored: 'Uncensored, unrestricted conversations',
		planPaywallBenefitPrivatePhotos: 'Exclusive private photos',
		planPaywallBenefitPriorityAi: 'Priority AI processing',
		planPaywallHeroTitle: 'Premium access',
		planDurationBasic: '1 month of full access',
		planDurationPro: '3 months of full access',
		planDurationPremium: '6 months of full access',
		planPaywallSelectPlan: 'Select a plan',
		planPaywallContinue: 'Continue ({price})',
		planPaywallPopular: 'Popular',
		planCheckoutSectionEyebrow: 'Checkout',
		planCheckoutSectionTitle: 'Payment details',
		planCheckoutSectionSubtitle: 'Choose a method and complete your purchase',
		planCheckoutSelectedPlan: 'Selected plan',
		planCheckoutClose: 'Close plan selection',
		planCheckoutCompleteTitle: 'Complete checkout',
		planCheckoutOneOffSubtitle: 'Secure payment via Stripe.',
		planCheckoutSubscriptionSubtitle:
			'Secure monthly subscription via Stripe. Enter your card details below.',
		planCheckoutRecurring: 'Recurring billing • Cancel anytime',
		planCheckoutProcessing: 'Processing...',
		planCheckoutCreatingSubscription: 'Creating subscription...',
		orderStatusVerifyingPayment: 'Verifying payment...',
		orderStatusPillVerifying: 'Verifying',
		orderStatusPillSuccess: 'Success',
		orderStatusPillFailed: 'Failed',
		orderStatusRedirecting: 'Redirecting shortly...',
		orderStatusVerifyingPaymentDescription:
			'We are confirming your payment. This may take up to 2 minutes.',
		orderStatusPaymentSuccess: 'Plan paid!',
		orderStatusPaymentSuccessDescription:
			'Your subscription is active. Redirecting you shortly.',
		orderStatusTokensSuccess: 'Sparks topped up!',
		orderStatusTokensSuccessDescription:
			'Payment confirmed. Returning you to chat shortly.',
		orderStatusPaymentFailed: 'Payment failed',
		orderStatusPaymentFailedDescription:
			'We could not confirm your payment. Please try again or contact support.',
		orderStatusPaymentTimeout:
			'Payment could not be confirmed within 2 minutes. Please try again.',
		orderStatusBackToCheckout: 'Back to checkout',
		orderStatusGoToLogin: 'Go to login',
		planCheckoutSubscribe: 'Subscribe ({price})',
		planCheckoutPaymentLabel: 'Payment method',
		planCheckoutCardLabel: 'Card details',
		planCheckoutSubscribeTermsPrefix: 'By subscribing, you agree to our',
		planCheckoutPay: 'Pay {price}',
		planCheckoutTermsPrefix: 'By completing your purchase, you agree to our',
		planCheckoutTermsLink: 'Terms of Service',
		planCheckoutTermsAnd: 'and',
		planCheckoutPrivacyLink: 'Privacy Policy',
		planCheckoutSecureStripe: 'Stripe · encrypted · secure',
		planCheckoutBadge: 'Premium',
		planCheckoutLoadingPayment: 'Loading payment form...',
		planCheckoutPaymentError: 'Could not initialize payment. Please try again.',
		planCheckoutStripeMissing: 'Stripe public key is missing (VITE_STRIPE_PUBLIC_KEY).',
		planCheckoutLoginRequired: 'Log in to complete your plan purchase.',
		tokensExhaustedTitle: 'You ran out of sparks',
		tokensExhaustedDescription:
			'Top up your sparks to keep chatting and generating new content.',
		tokensExhaustedHeroTitle: 'Top up sparks',
		tokensExhaustedHeroDescription:
			'Choose a spark package and return to chat without interruption.',
		generatedImageAlt: 'Generated image',
		generatedVideoAlt: 'Generated video',
		videoLoadError: 'Could not load this video. Please refresh and try again.',
		feedbackActionsLabel: 'Feedback',
		feedbackLikeTitle: 'What did you like about this response?',
		feedbackDislikeTitle: 'What should we improve?',
		feedbackDislikePlaceholder: 'Required: Describe the issue (min 5 characters)',
		feedbackOptionalPlaceholder: 'Your feedback (optional)',
		feedbackSkip: 'Skip',
		feedbackSubmit: 'Submit',
		feedbackSending: 'Sending...',
		feedbackMinLengthHint:
			'Write a message (min 5 characters) or press "Skip" to submit feedback without text.',
		feedbackHint:
			'You can leave a short message or skip and close the window.',
		feedbackSkippedText: 'No text provided (Skipped)',
		messageActionsLabel: 'Message actions',
		tooltipLike: 'Like',
		tooltipDislike: 'Dislike',
		tooltipListen: 'Listen',
		listenToMessage: 'Listen to this message',
		speakLoading: 'Loading voice...',
		speakStop: 'Stop playback',
		speakError: 'Something went wrong while playing the voice. Please try again.',
		galleryClose: 'Close',
		galleryPrev: 'Previous',
		galleryNext: 'Next',
		galleryError: 'Error loading image',
		hide: 'Hide',
		showChatList: 'Show chat list',
		hideChatList: 'Hide chat list',
		showProfilePanel: 'Show profile panel',
		hideProfilePanel: 'Hide profile panel',
		more: 'More',
		imagesCount: 'Photos & videos ({count})',
		imagesLabel: 'Images',
		noImagesYet: 'No images have been generated in this conversation yet.',
		imagePlaceholder: 'Your next moment lands here',
		archiveConversation: 'Archive {name} conversation',
		deleteConversationTitle: 'Delete conversation?',
		deleteConversationWarning: 'This action cannot be undone.',
		deleteConversationDeleting: 'Deleting...',
		deleteConversationDeleted: 'Deleted',
		deleteConversation: 'Delete conversation',
		no: 'No',
		yes: 'Yes',
		newChat: 'New chat',
		search: 'Search',
		searchPlaceholder: 'Search conversations...',
		loadingConversations: 'Loading conversations',
		noConversationsYet: 'No conversations yet.',
		profileInfoAria: 'Profile information for {name}',
		thinking: 'Thinking',
		typing: 'Writing',
		processingMessage: 'Processing message...',
		cancelRecording: 'Cancel',
		noDescription: 'No detailed description for this profile.',
		newChatModalTitle: 'Choose your desired partner!',
		newChatModalLoading: 'Loading partners',
		newChatModalNoPersons: 'No partners available.',
	},

	audioError: {
		title: 'Microphone problem',
		subtitle:
			'Could not access the microphone. Check your device connection and browser permissions.',
		deniedSubtitle:
			'Microphone access was blocked. Allow the microphone for this site in your browser settings.',
		notFoundSubtitle:
			'No microphone was detected. Connect an audio device or check your system settings.',
		inUseSubtitle:
			'The microphone is being used by another app. Close it and try again.',
		unsupportedSubtitle:
			'Your browser does not support voice recording in this app.',
		timeoutSubtitle:
			'Microphone access timed out. Check permissions and try again.',
		unknownSubtitle:
			'An unexpected microphone problem occurred. Check your device and permissions.',
		mimeTypeUnsupportedSubtitle:
			'Your browser does not support audio recording. Please try using Chrome, Safari, or Firefox.',
		checkPerms: 'How to allow the microphone:',
		guides: {
			chrome: 'Google Chrome',
			safari: 'Safari',
			mac: 'macOS',
			iphone: 'iPhone / iPad',
		},
		or: 'or',
		mobileCta: 'You can also use the mobile app:',
		android: 'Android',
		ios: 'iOS',
		retry: 'Refresh page',
		tipRefresh:
			'After changing permissions, refresh the page and start the call again.',
	},

	currency: { symbol: '€', code: 'eur' },
	promoPlan: {
		name: 'PREMIUM',
		title: '6 months',
		discount: '80%',
		prev: '149.99',
		current: '29.99',
		daily: '0.17',
		popular: true,
		type: 'PREMIUM',
	},
	plans: [
		{
			name: 'PREMIUM',
			title: '6 months',
			discount: '70%',
			prev: '149.99',
			current: '44.99',
			daily: '0.25',
			popular: true,
			type: 'PREMIUM',
		},
		{
			name: 'PRO',
			title: '3 months',
			discount: '60%',
			prev: '74.99',
			current: '29.99',
			daily: '0.33',
			popular: false,
			type: 'PRO',
		},
		{
			name: 'BASIC',
			title: '1 month',
			discount: '40%',
			prev: '24.99',
			current: '14.99',
			daily: '0.50',
			popular: false,
			type: 'BASE',
		},
	],
};
